import React from 'react';

import { useSelector } from 'react-redux';

import {
    Text,
} from 'wanderu-components';
import { localize, selectLocale } from 'wanderu-i18n';

import { LineItem } from '../../LineItem';
import { TripLegPrice } from '../TripLegPrice';

import styles from './TripPriceDetails.scss';

import type { TripLegItems } from '../../types';
import type { TFunction } from 'i18next';

interface TripPriceDetailsProps {
    isReturnTrip: boolean;
    legs: TripLegItems[];
    t: TFunction;
}

function TripPriceDetails({
    isReturnTrip,
    legs,
    t,
}: TripPriceDetailsProps) {
    const locale = useSelector(selectLocale);

    const tripDirection = isReturnTrip
        ? 'return'
        : 'departure';

    return (
        <div className={styles.container}>
            <LineItem
                leftCol={
                    <Text className={styles.left} variant="text-s" bold>
                        {t(tripDirection)}
                    </Text>
                }
                leftColStyles={styles.lineItem}
            />
            {legs?.map((leg) => (
                <TripLegPrice
                    isReturnTrip={isReturnTrip}
                    key={leg.tripId}
                    locale={locale}
                    {...leg}
                />
            ))}
        </div>
    );
}

export { TripPriceDetails };

export default localize(TripPriceDetails, ['t'], 'baseApp');
